module.exports = __webpack_public_path__ + "img/spirit-icon-2.fcceb478.png";